import { Component, OnInit,inject } from '@angular/core';
import { CoachService } from '../../_core/services/coach.service';
import { CreateCoachComponent } from '../../my-coaches/create-coach/create-coach.component';
import { Coach } from '../../_shared/models/coach.model'; 
import { ModalController } from '@ionic/angular';



@Component({
  selector: 'app-admin-coaches',
  templateUrl: './admin-coaches.component.html',
  styleUrls: ['./admin-coaches.component.scss'],
  standalone: false
})
export class AdminCoachComponent implements OnInit {
  coaches: Coach[] = [];
  totalRecords = 0;
  showOnlyAdminTeams = false;
private modalController = inject(ModalController);

  constructor(private coachService: CoachService) {}

  ngOnInit(): void {
    this.getCoaches();
  }

  getCoaches(): void {
    this.coachService.getAllCoaches().subscribe(res => {
      this.coaches = res.players;
      this.totalRecords = this.coaches.length;
    });
  }

  searchedTeams(event: any[]): void {
    this.coaches = event;
    this.totalRecords = event.length;
  }

  async createCoach() {
    const modal = await this.modalController.create({
      component: CreateCoachComponent,
      componentProps: {
        isEdit: false
      }
    });

    modal.onDidDismiss().then((result) => {
      if (result.data) {
        this.getCoaches();
      }
    });

    return await modal.present();
  }
}
